import CryptoJs from 'crypto-js';

const key = CryptoJs.enc.Utf8.parse('1234ab567cd890ef'); //十六位十六进制数作为密钥
const iv = CryptoJs.enc.Utf8.parse('98ef765cd43210ab'); //十六位十六进制数作为密钥偏移量

//解密方法
const Decrypt = (word) => {
  let encryptedHexStr = CryptoJs.enc.Hex.parse(word);
  let srcs = CryptoJs.enc.Base64.stringify(encryptedHexStr);
  let decrypt = CryptoJs.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJs.mode.CBC,
    padding: CryptoJs.pad.Pkcs7,
  });
  let decryptedStr = decrypt.toString(CryptoJs.enc.Utf8);
  return decryptedStr.toString();
};

//加密方法
const Encrypt = (word) => {
  let srcs = CryptoJs.enc.Utf8.parse(word);
  let encrypted = CryptoJs.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJs.mode.CBC,
    padding: CryptoJs.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString().toUpperCase();
};

export default {
  Decrypt,
  Encrypt,
};
